export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -left-24 top-8 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-20 bottom-4 h-72 w-72 rounded-full bg-secondary-100/70 blur-3xl"></div>

      <div className="mx-auto grid max-w-7xl gap-12 px-4 pb-16 pt-12 md:px-6 md:pb-24 md:pt-16 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-10">
        {/* 文案优先 */}
        <div className="relative z-10 max-w-2xl">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            备用通道已开启 · 全程在线
          </div>

          <h1 className="font-heading text-4xl font-black leading-tight text-foreground-950 md:text-[3.4rem] md:leading-[1.15]">
            吃瓜入口，<br className="hidden sm:block" />
            常回来看看<span className="text-primary-500">就不会走丢</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            这里是大家攒了好久的吃瓜大本营。新入口永久有效，换址信息会第一时间贴在这里。
            老用户直接把本站收藏好，再大的风浪也不怕，随时进来，吃瓜不迷路。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="#guide"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-arrow-right-circle-line text-base"></i>
              获取最新入口
            </a>
            <a
              href="#hot"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-background-400 hover:bg-background-100"
            >
              <i className="ri-fire-line text-base text-primary-500"></i>
              先看今日热瓜
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-500"></i>
              永久有效入口
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-refresh-line text-secondary-600"></i>
              换址实时公告
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-user-follow-line text-accent-500"></i>
              老用户免注册
            </span>
          </div>
        </div>

        {/* 视觉陪衬：浮动话题卡 */}
        <div className="relative z-10 mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative h-[420px] md:h-[460px]">
            <div className="absolute right-0 top-0 h-56 w-56 animate-floaty overflow-hidden rounded-2xl object-cover">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20evening%20entertainment%20gossip%20community%20lounge%20scene%20with%20popcorn%20and%20warm%20string%20lights%2C%20relaxed%20friends%20chatting%20vibe%2C%20editorial%20lifestyle%20photography%2C%20soft%20cream%20and%20coral%20tone%2C%20high%20detail&width=560&height=560&seq=hero-floating-01&orientation=squarish"
                alt="吃瓜社区氛围场景"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute left-0 top-16 h-52 w-52 animate-floaty overflow-hidden rounded-2xl object-cover [animation-delay:1s]">
              <img
                src="https://readdy.ai/api/search-image?query=floating%20topic%20bubbles%20and%20chat%20bubbles%20on%20a%20clean%20warm%20background%2C%20lively%20discussion%20concept%20art%2C%20soft%20cream%20and%20muted%20green%20tones%2C%20editorial%20illustration%20style%2C%20high%20detail&width=520&height=520&seq=hero-floating-02&orientation=squarish"
                alt="讨论气泡概念图"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="absolute bottom-4 left-1/2 flex w-72 -translate-x-1/2 items-center gap-3 rounded-xl border border-background-200/80 bg-background-50/95 p-3 shadow-sm">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-chat-heart-line"></i>
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-foreground-900">
                  正在实时讨论中
                </p>
                <p className="text-xs text-foreground-500">3.2 万人在线 · 新帖持续刷新</p>
              </div>
              <i className="ri-arrow-right-up-line ml-auto text-lg text-primary-500"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}